import { MouseEvent, useEffect, useState } from 'react'
import { styled } from '@mui/material'
import { getProjectPlanUuidByWbsItemUuid } from '../../../lib/functions/projectPlan'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { BreadCrumb } from '../../../store/breadcrumb'
import { colorPalette } from '../../style/colorPalette'
import ProjectPlanNewBreadcrumb from '../ProjectPlanNew/components/Header/ProjectPlanNewBreadcrumb'
import { WbsItemType } from '../../../domain/entity/WbsItemEntity'

// 配列リテラルを props に直接渡すと毎レンダー新しい参照になり、
// 子の useEffect の依存配列が変わって path API が無限にコールされる。
const OPTION_TYPES: WbsItemType[] = [
  WbsItemType.WORKGROUP,
  WbsItemType.PROCESS,
  WbsItemType.DELIVERABLE_LIST,
  WbsItemType.DELIVERABLE,
]

type OwnProps = {
  rootWbsItemUuid: string
  onSelectBreadcrumb: (
    event: MouseEvent | Event,
    breadcrumb: BreadCrumb
  ) => void | Promise<void>
}

const SprintReportBreadcrumb = ({
  rootWbsItemUuid,
  onSelectBreadcrumb,
}: OwnProps) => {
  const [projectPlanUuid, setProjectPlanUuid] = useState<string | undefined>()

  useEffect(() => {
    const getProjectPlanUuid = async () => {
      const uuid = await getProjectPlanUuidByWbsItemUuid(rootWbsItemUuid)
      setProjectPlanUuid(uuid)
    }
    getProjectPlanUuid()
  }, [rootWbsItemUuid])

  if (!projectPlanUuid) return null

  return (
    <Root>
      <ProjectPlanNewBreadcrumb
        rootProjectPlanUuid={projectPlanUuid}
        onSelectBreadcrumb={onSelectBreadcrumb}
        optionsTypes={OPTION_TYPES}
      />
    </Root>
  )
}

// 旧 BulkSheet 時代は親に horizontal padding があったため width: 100vw / 負の marginLeft で「親をはみ出して画面端まで広げる」工夫が必要だった。
// 新 SprintReport では PageArea が直接の親で水平 padding を持たないため、その工夫を続けると左端のアイコンが負のマージン領域にめり込んで隠れる。
// 通常の幅 (100%) で PageArea に揃え、はみ出しトリックは外す。
const Root = styled('div')({
  width: '100%',
  background: colorPalette.monotone[1],
  overflowX: 'auto',
  '& ol': {
    flexWrap: 'nowrap',
  },
})

export default projectPrivate(SprintReportBreadcrumb)
